export default __webpack_public_path__ + "static/media/Build6.b0b65003.jpg";